import { useEffect, useState } from 'react';
import { css, SerializedStyles } from '@emotion/react';

export const DEFAULT_SAFE_AREA_INSET_BOTTOM = '34px';

/**
 * Applies the given styles to the following devices with a notch:
 * - iPhone X
 * - iPhone XS
 * - iPhone XS Max
 * - iPhone XR
 * - iPhone 11
 * - iPhone 11 Pro
 * - iPhone 11 Pro Max
 * - iPhone 12 Mini
 * - iPhone 12
 * - iPhone 12 Pro
 * - iPhone 12 Pro Max
 * - iPhone 13 Mini
 * - iPhone 13
 * - iPhone 13 Pro
 * - iPhone 13 Pro Max
 * - iPhone 14
 * - iPhone 14 Pro
 * - iPhone 14 Plus
 * - iPhone 14 Pro Max
 */
export const notchiPhoneMediaQuery = (styles: SerializedStyles) => css`
  /* iPhone X, iPhone XS, iPhone 11 Pro */
  @media screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
    ${styles}
  }

  /* iPhone XS Max, iPhone XR, iPhone 11, iPhone 11 Pro Max */
  @media screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2),
    screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) {
    ${styles}
  }

  /* iPhone 12 Mini */
  @media screen and (device-width: 360px) and (device-height: 780px) and (-webkit-device-pixel-ratio: 3) {
    ${styles}
  }

  /* iPhone 12, iPhone 12 Pro */
  @media screen and (device-width: 390px) and (device-height: 844px) and (-webkit-device-pixel-ratio: 3) {
    ${styles}
  }

  /* iPhone 12 Pro Max */
  @media screen and (device-width: 428px) and (device-height: 926px) and (-webkit-device-pixel-ratio: 3) {
    ${styles}
  }

  /* iPhone 13 Mini */
  @media screen and (device-width: 360px) and (device-height: 780px) and (-webkit-device-pixel-ratio: 3) {
    ${styles}
  }

  /* iPhone 13, iPhone 13 Pro */
  @media screen and (device-width: 390px) and (device-height: 844px) and (-webkit-device-pixel-ratio: 3) {
    ${styles}
  }

  /* iPhone 13 Pro Max */
  @media screen and (device-width: 428px) and (device-height: 926px) and (-webkit-device-pixel-ratio: 3) {
    ${styles}
  }

  /* iPhone 14 */
  @media screen and (device-width: 390px) and (device-height: 844px) and (-webkit-device-pixel-ratio: 3) {
    ${styles}
  }

  /* iPhone 14 Pro */
  @media screen and (device-width: 393px) and (device-height: 852px) and (-webkit-device-pixel-ratio: 3) {
    ${styles}
  }

  /* iPhone 14 Plus */
  @media screen and (device-width: 428px) and (device-height: 926px) and (-webkit-device-pixel-ratio: 3) {
    ${styles}
  }

  /* iPhone 14 Pro Max */
  @media screen and (device-width: 430px) and (device-height: 932px) and (-webkit-device-pixel-ratio: 3) {
    ${styles}
  }
`;

export const useNotchiPhoneSafeArea = (enabled: boolean) => {
  const [safe_area_inset_bottom, setSafeAreaInsetBottom] = useState<string | null>(null);

  /**
   * 실제 안전영역 px 값을 가져온다.
   * 웹뷰 초기 로드 구간에 safe-area 값이 잡히지 않는 이슈 대응
   */
  useEffect(() => {
    if (!enabled) return;

    function getSafeAreaInsetBottomValue() {
      try {
        const root_style = getComputedStyle(document.documentElement);
        const sab = root_style.getPropertyValue('--sab').trim();

        setSafeAreaInsetBottom(sab);
      } catch (err) {
        console.error(err);
      }
    }

    getSafeAreaInsetBottomValue();
  }, [enabled]);

  return {
    safe_area_inset_bottom,
  };
};
